import React from "react";
import Link from "components/link";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  kitchenware, kitchenwareContent, kitchenwareTitle,
  kitchenwareCard, cardImg, cardBody, kitchenwareSubtitle,
  cardContent, cardTitle, cardLink, kitchenWareItemsMobile, kitchenWareItemsDesktop
} from "./style.mod.scss";
import getImagePath from "helpers/get-image-path";
import asHTML from "helpers/as-html";
import ArrowRight from "assets/svgs/arrow-right.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel } from "swiper";


const Kitchenware = ({ data }) => {
  const title = data?.title;
  const subtitle = data?.subtitle;
  const kitchenWareData = data?.kitchenWareData;
  const sliderDesktop = data?.sliderInDesktop;

  var settings = {
    spaceBetween: 25,
    slidesPerView: 1.1,
    pagination: { clickable: true },
    navigation: { clickable: true },
    modules: [Navigation, Mousewheel],
    enabled: true,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 10,
        pagination: false,
      },
      992: {
        slidesPerView: 3.4,
        spaceBetween: 15,
      },
      1025: {
        spaceBetween: 20,
        slidesPerView: 4.3,
      },
      1270: {
        spaceBetween: 25,
        slidesPerView: 4.3,
      }
    },
  };

  const CardItem = ({ module }) => (
    <div className={kitchenwareCard}>
      <Link className={cardLink} to={module?.url} style={{ backgroundColor: data.bgColor && data.bgColor.hex }}>
        <img className={cardImg} srcSet={getImagePath(module?.mainimage)} alt={module?.mainimage?.alt} />
        <div className={cardBody}>
          <div className={cardContent}>
            <div className={cardTitle}><h3>{asHTML(module?.title)}</h3>
              <ArrowRight />
            </div>
          </div>
        </div>
      </Link>
    </div>
  );

  return (
    <div className={kitchenware} style={{ backgroundColor: data.bgColor && data.bgColor.hex }}>
      <Container>
        <Row>
          <Col lg="4" md="12" sm="12">
            <div className={kitchenwareContent}>
              <h6 className={kitchenwareSubtitle}>{subtitle}</h6>
              <h1 className={kitchenwareTitle}>{title}</h1>
            </div>
          </Col>
          <Col lg="8" md="12" sm="12" className={kitchenWareItemsDesktop}>
            {sliderDesktop ?
              <Swiper {...settings}>
                {kitchenWareData.map((module, index) => (
                  <SwiperSlide key={`mobile-${index}`}>
                    <div style={{ width: "100%" }}>
                      <CardItem module={module} />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper> :
              <Row>
                {kitchenWareData?.map((module) => (
                  <Col key={module._key} lg="3" md="12" sm="12">
                    <CardItem module={module} />
                  </Col>))}
              </Row>
            }
          </Col>

          <div className={kitchenWareItemsMobile}>
            {kitchenWareData?.map((module) => (
              <Col key={module._key} xs="6" md="6" lg="2">
                <CardItem module={module} />
              </Col>))}
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Kitchenware;
